import { MdAutoAwesome } from "react-icons/md";
import Card, { CardHeader } from "components/card";
import { EmptyState } from "components/states";
import { formatDate } from "utils/format";

const AIWeeklySummary = ({ summary }) => {
  if (!summary) return null;

  const scores = [
    { label: "Productivity", value: summary.productivityScore },
    { label: "Satisfaction", value: (summary.avgSatisfaction || 0).toFixed(1) },
    { label: "Contribution", value: (summary.avgContribution || 0).toFixed(1) },
  ];

  return (
    <Card padding="md">
      <CardHeader
        title={
          <span className="inline-flex items-center gap-2">
            <MdAutoAwesome aria-hidden="true" className="h-5 w-5 text-accent" />
            AI Summary
          </span>
        }
        description={`Week of ${formatDate(summary.weekOf)}`}
        actions={
          <dl className="flex items-center gap-5">
            {scores.map((score) => (
              <div key={score.label} className="text-center">
                <dt className="text-xs text-fg-muted">{score.label}</dt>
                <dd className="text-lg font-bold text-fg">{score.value}</dd>
              </div>
            ))}
          </dl>
        }
      />
      {summary.aiSummary ? (
        <p className="mt-3 text-sm text-fg">{summary.aiSummary}</p>
      ) : (
        <EmptyState variant="inline" title="No AI summary available for this week" />
      )}
    </Card>
  );
};

export default AIWeeklySummary;
